module.exports = __webpack_public_path__ + "img/yeqian.6507f27f.png";